import { AxiosResponse } from 'axios';
import { Endpoints } from 'modules/core/constants';
import { Api } from 'api/api';
import {
  IGamificationSummary,
  IAchievementWithProgress,
  ITrackActivityPayload,
  ITrackActivityResponse,
} from 'modules/core/types/gamification';

class GamificationApi extends Api {
  trackActivity = (data: ITrackActivityPayload): Promise<AxiosResponse<ITrackActivityResponse>> =>
    this.api.post(Endpoints.gamificationTrack, data);

  getAchievements = (): Promise<AxiosResponse<IAchievementWithProgress[]>> =>
    this.api.get(Endpoints.gamificationAchievements);

  getSummary = (): Promise<AxiosResponse<IGamificationSummary>> => this.api.get(Endpoints.gamificationSummary);
}

export default new GamificationApi();
